import { render } from "./AdminUsefulInformation.vue?vue&type=template&id=074f7d0c&scoped=true"
import script from "./AdminUsefulInformation.vue?vue&type=script&lang=js"
export * from "./AdminUsefulInformation.vue?vue&type=script&lang=js"

import "./AdminUsefulInformation.vue?vue&type=style&index=0&id=074f7d0c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-074f7d0c"]])

export default __exports__